<template>
  <div class="ae-component-error-wrapper">
    <slot name="form-item"></slot>
    <div ref="isErrorElement" class="error-message" v-if="isError">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    errorMessage: {
      type: String,
      default: 'Error'
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ae-component-error-wrapper {
  display: inline-flex;
  margin: 0 8px;
  flex-direction: column;

  .error-message {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AeErrorWrapper.vue